// componente che contiene tutti i metodi utilizzati per gestire i pannelli; queste funzioni sono richiamate esternamente
// dalle altre componenti che costituiscono tutto il blocco di gestione pannelli (backup-edit e backup-list)

import { Injectable } from '@angular/core';
import { Backup } from './backup.model';
import { Subject } from 'rxjs';

@Injectable()
export class BackupService {
  private backup: Backup[] = [];
  backupChanged = new Subject<Backup[]>();
  backupEditMode = new Subject<number>();

  constructor(
  ) { }

  ngOnInit() {
  }

  // metodo che restituisce tutti i pannelli memorizzati localmente
  getBackup() {
    return this.backup;
  }

  // metodo richiamato all'inserimento di un nuovo pannello; viene identificata la posizione nella tabella dell'elemento da aggiungere
  setBackup(backup: Backup[]) {
    if (backup !== null) {
      this.backup = backup;
      this.backupChanged.next(this.backup.slice());
    }
  }

}
